//import Libraries
import React from 'react';

//import Components
import Auxillary from '../../../hoc/Auxillary';
import Language from '../../../language/language.json';

//import Style classes
import './Greeting.css';

const greeting = (props) => {
    const greetingText = Language.greetings[props.lang];
    console.log("[Greeting.js]", greetingText)
    
    return (
        <React.Fragment>
            <div className="GreetingImage">
                <img src={require("../../../assets/greeting/image.png")}/>
            </div>
            <p>
                {greetingText}
            </p>
        </React.Fragment>
    )
}

export default greeting;


// WEBPACK FOOTER //
// ./src/pages/About/Greeting/Greeting.js